import * as React from "react";
import { getPortalRootId } from "./utils.ts";
/**
 * A root div that portals get spawned inside of.
 * A global instance of this should exist high up in the React tree for each of our SPA's.
 * Custom PortalRoot locations can be implemented for advanced needs (relative positioning, etc.)
 * For majority of portals, you shouldn't need to use this component (already exists in shared React tree).
 */ export var PortalRoot = function(param) {
    var name = param.name, className = param.className, style = param.style;
    return /*#__PURE__*/ React.createElement("div", {
        id: getPortalRootId(name),
        className: className,
        style: style
    });
};
